<template>
	<div class="bg-absen">
		<img src="../../../assets/icons/close-white.svg" alt=""
		     class="close-foto-absensi"
		     @click="back"
		>
		<div class="foto-absensi" :style="{backgroundImage: fotoAbsensi}"></div>
	</div>
</template>

<script>
	export default {
		name: "FotoAbsen",
		props: ["fotoAbsensi"],
		mounted() {
			this.backButtonPressed(this.back)
		},
		methods: {
			back() {
				this.$emit("back")
			}
		},
	}
</script>

<style>
	.bg-absen {
		position: relative;
		background: #000;
		height: 100vh;
	}
	.foto-absensi {
		height: 100%;
		width: 100%;
		background-size: contain;
		background-position: center;
		background-repeat: no-repeat;
	}
	.close-foto-absensi {
		position: absolute;
		top: 14px;
		left: 20px;
	}
</style>